import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import { useUserProfile } from '../useUserProfileInfo.esm.js';
import { sidebarConfig } from '@backstage/core-components';

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: ({ size }) => size,
    height: ({ size }) => size,
    fontSize: ({ size }) => size * 0.7,
    border: `1px solid ${theme.palette.textSubtle}`
  }
}));
const UserSettingsSignInAvatar = (props) => {
  const { size } = props;
  const { iconSize } = sidebarConfig;
  const classes = useStyles(size ? { size } : { size: iconSize });
  const { profile } = useUserProfile();
  return /* @__PURE__ */ React.createElement(
    Avatar,
    {
      src: profile.picture,
      className: classes.avatar,
      alt: "Profile picture"
    }
  );
};

export { UserSettingsSignInAvatar };
//# sourceMappingURL=UserSettingsSignInAvatar.esm.js.map
